import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbDropdownModule, NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-tax-category-slab-form',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule, NgbDropdownModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './tax-category-slab-form.component.html',
  styleUrl: './tax-category-slab-form.component.scss'
})
export class TaxCategorySlabFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  TaxCategorys = [] as any;
  FinancialYears: any[] = [];
  Detail = {
    SelectType: 'insert',
    ESS_TaxSlabMasterID: 0,
    ESS_TaxCategoryMasterID: null,
    SlabFrom: null as any,
    SlabTo: null as any,
    PercValue: null as any,
    // YearStart: null as any,
    // YearEnd: null as any,
    FinancialYearStart: null as any,
    FinancialYearEnd: null as any,
    IsNewRegime: false,
    ESS_TaxFinancialYearID: null
  }

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private incometax: IncometaxService,
    protected dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.Detail.ESS_TaxSlabMasterID = this.ID;
  }

  ngOnInit(): void {
    this.TaxCategoryMasterSelectLoad();
    this.ESS_TaxFinancialYearSelect();
    if (this.Detail.ESS_TaxSlabMasterID == undefined) {
      this.Detail.ESS_TaxSlabMasterID = 0;
    }
  }

  Validate(form: any) {
    if (form.valid) {
      // if (parseFloat(this.Detail.SlabFrom) >= parseFloat(this.Detail.SlabTo)) {
      //   this.toast.show({ message: "To amount greater than from amount", type: toastTypeEnum.danger });
      // } else if (this.Detail.PercValue <= 0 || this.Detail.PercValue > 100) {
      //   this.toast.show({ message: "Please enter percentage in between 0 to 100 only", type: toastTypeEnum.danger });
      // } else if (this.Detail.YearStart == null || this.Detail.YearStart.toString().length != 4 || this.Detail.YearStart <= 0) {
      //   this.toast.show({ message: "Please enter financial year start year", type: toastTypeEnum.danger });
      // } else {
      //   this.Detail.YearEnd = parseInt(this.Detail.YearStart) + 1;
      //   this.Detail.FinancialYearStart = "01 APR " + this.Detail.YearStart.toString();
      //   this.Detail.FinancialYearEnd = "31 MAR " + this.Detail.YearEnd.toString();;
      //   this.TaxSlabMasterInsertUpdate();
      // }
      this.Detail.FinancialYearStart = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear() });
      this.Detail.FinancialYearEnd = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Detail.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear() });
      this.TaxSlabMasterInsertUpdate();

    }
    else {
      form.submitted = true;
    }
  }

  TaxCategoryMasterSelectLoad() {
    this.isDisabled = true;
    this.incometax.TaxCategoryMasterSelectLoad({ 'SelectType': 'S', ESS_TaxCategoryMasterID: 0 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TaxCategorys = Object.values(response.Table);
        } else {
          this.TaxCategorys = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  TaxSlabMasterSelectLoad() {
    this.Detail.ESS_TaxSlabMasterID = this.ID;
    this.isDisabled = true;
    this.incometax.TaxSlabMasterSelectLoad({ SelectType: 'S', ESS_TaxSlabMasterID: this.Detail.ESS_TaxSlabMasterID, ESS_TaxCategoryMasterID: 0, FinancialYearFrom: '', FinancialYearTo: '' }).subscribe({
      next: (response) => {
        if (response.Table || response.Table.length > 0) {
          this.Detail = response.Table[0];
          this.Detail.SelectType = 'update';
          try {
            this.Detail.ESS_TaxFinancialYearID = this.FinancialYears.filter(e => e.FinancialYearStart == response.Table[0].FinancialYearStart && e.FinancialYearEnd == response.Table[0].FinancialYearEnd)[0].ESS_TaxFinancialYearID;
          } catch {
            this.Detail.ESS_TaxFinancialYearID = null;
          }
          // if (response.Table[0].FinancialYearStart != null && response.Table[0].FinancialYearStart != '') {
          //   this.Detail.YearStart = new Date(response.Table[0].FinancialYearStart).getFullYear()
          // }
          // if (response.Table[0].FinancialYearEnd != null && response.Table[0].FinancialYearEnd != '') {
          //   this.Detail.YearEnd = new Date(response.Table[0].FinancialYearEnd).getFullYear()
          // }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async TaxSlabMasterInsertUpdate() {
    if (this.common.PageRight.IsEdit) {
      this.isDisabled = true;
      this.incometax.TaxSlabMasterInsertUpdate(this.Detail).subscribe({
        next: async (response) => {
          if (response.Error_Code == '675' || response.Error_Code == '676') {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              this.close(true);
            });
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  // SetFinancialYearEnd() {
  //   if (this.Detail.YearStart != null && this.Detail.YearStart.toString().length == 4 && this.Detail.YearStart > 0) {
  //     this.Detail.YearEnd = parseInt(this.Detail.YearStart) + 1;
  //   } else {
  //     this.Detail.YearEnd = null
  //   }
  // }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table;
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });
        } else {
          this.FinancialYears = [];
        }
        if (this.ID > 0) {
          this.TaxSlabMasterSelectLoad();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    })
  };

  close(flag = false) {
    this.activeModal.close(flag);
  }
}
